.root,
.titleImage {
	/* CSS Modules theming placeholders */
}

.title,
.titleBox {
	flex: 2;
	text-align: center;
}
